import axios from 'axios'
import config from '../config'
import { getDoctorToken } from '../utils'

const getTestBookListApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}test-master/get-test-list`,
        method: "get",
        params: params,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
        }
    })

    return response

}

export default getTestBookListApi